/* eslint-disable @typescript-eslint/camelcase */
import i18n from 'i18n';
import * as Yup from 'yup';

export default (shouldValidateAdminBindPass?: boolean) => {
  const fieldsRequirements = Yup.string()
    .required(i18n.t('REQUIRED_FIELD_KEY'))
    .nullable();
  const fieldsAD = Yup.string()
    .when('ldap_type', {
      is: 'external',
      then: fieldsRequirements,
      otherwise: Yup.string().nullable(true),
    })
    .when('ldap_type', {
      is: 'managed',
      then: fieldsRequirements,
      otherwise: Yup.string().nullable(true),
    });

  return Yup.object().shape({
    name: Yup.string()
      .required(i18n.t('REQUIRED_FIELD_KEY'))
      .max(
        60,
        i18n.t('MAX_LENGTH_KEY', {
          value: 60,
        })
      ),
    company_uuid: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
    frontend: Yup.object().shape({
      enable_new_interface: Yup.boolean().required(
        i18n.t('REQUIRED_FIELD_KEY')
      ),
      language: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
    }),
    active_directory: Yup.object().shape({
      ldap_type: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
      ldap_server: fieldsAD,
      admin_bind_pass: shouldValidateAdminBindPass
        ? fieldsAD.max(44, i18n.t('MAX_LENGTH_KEY', { value: 44 }))
        : fieldsAD,
      admin_bind_dn: Yup.string()
        .when('ldap_type', {
          is: 'external',
          then: fieldsRequirements,
          otherwise: Yup.string().nullable(true),
        })
        .when('ldap_type', {
          is: 'managed',
          then: fieldsRequirements,
          otherwise: Yup.string().nullable(true),
        }),

      base_dn: fieldsAD,
      ad_domain: fieldsAD,
    }),
    recaptcha: Yup.object().shape({
      reason: Yup.string().when('enabled', {
        is: true,
        then: Yup.string().nullable(true),
        otherwise: Yup.string()
          .min(
            20,
            i18n.t('REQUIRE_MIN_LENGTH_TEXT_KEY', {
              min_length: 20,
            })
          )
          .max(
            100,
            i18n.t('REQUIRE_MAX_LENGTH_TEXT_KEY', {
              max_length: 100,
            })
          )
          .required(i18n.t('REQUIRED_FIELD_KEY'))
          .trim(),
      }),
    }),
  });
};

export const passwordValidationSchema = Yup.object().shape({
  action_reason: Yup.string()
    .required(i18n.t('REQUIRED_FIELD_KEY'))
    .max(
      280,
      i18n.t('REQUIRE_MAX_LENGTH_TEXT_KEY', {
        max_length: 280,
      })
    ),
  new_ad_password: Yup.string()
    .required(i18n.t('REQUIRED_FIELD_KEY'))
    .max(44, i18n.t('MAX_LENGTH_KEY', { value: 44 })),
  new_ad_password_confirmation: Yup.string()
    .oneOf([Yup.ref('new_ad_password'), null], i18n.t('PASSWORD_NOT_MATCH_KEY'))
    .required(i18n.t('REQUIRED_FIELD_KEY')),
});
